module.exports = __webpack_public_path__ + "static/media/top-chevron.b96e40f6.svg";